import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TicketItem, TicketTagEssential, TicketTagItem } from 'src/app/api/models';
import { TicketService, TicketStatusService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-change-ticket-tag',
  templateUrl: './modal-change-ticket-tag.component.html',
  styleUrls: ['./modal-change-ticket-tag.component.scss'],
})
export class ModalChangeTicketTagComponent {
  ticket_id?: number;
  ticket_status_id?: number;
  current_tag?: TicketTagEssential;

  tags: TicketTagEssential[] = [];
  tag = new FormControl<TicketTagEssential | null | undefined>(undefined);
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private ticketStatusService: TicketStatusService,
    private messageService: MessageService,
    private ticketService: TicketService
  ) {
    this.ticket_id = config.data.ticket_id;
    this.ticket_status_id = config.data.ticket_status_id;
    this.current_tag = config.data.current_tag;
    this.tag.setValue(this.current_tag);
    console.log('config.data', config.data);
  }

  ngOnInit() {
    this.ticketStatusService
      .ticketStatusControllerFindOne({ id: this.ticket_status_id! })
      .subscribe({
        next: res => {
          this.tags = res.data.ticket_tags;
        },
      });
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ticketService
      .ticketControllerUpdate({
        id: this.ticket_id!,
        body: {
          ticket_tag_id: this.tag.value?.id || null,
          action: 'Cambio tag',
          ticket_status_id: this.ticket_status_id,
        },
      })
      .subscribe({
        next: res => {
          this.messageService.add({
            severity: 'success',
            summary: 'Modifica tag ticket',
            detail: 'Il tag è stato modificato con successo.',
          });
          this.ref.close();
        },
        error: err => {
          this.messageService.add({
            severity: 'error',
            summary: 'Modifica tag ticket',
            detail: 'Errore durante la modifica del tag',
          });
        },
      });
    // this.ref.close({ value: this.next_status.value });
  }
}
